export class LoadCurrentUserAction {
  static readonly type = '[User-set] Get and set User info';
}
